import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalPoliciesRoute } from '@jira/router-routes__eoc-policies-routes/src/globalPoliciesRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as alertPoliciesResources } from '@atlassian/eoc-policies/resources';
import type { Route } from '@atlassian/react-resource-router';
import { AlertPoliciesComponent, LazyAlertPolicies } from './ui/AlertPoliciesComponent.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const globalPoliciesRouteEntry: Route = createEntry(globalPoliciesRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: AlertPoliciesComponent,
	layout: opsSettingsLayout,

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...alertPoliciesResources(),
	],

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyAlertPolicies],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
